import { useMemo } from 'react';

/**
 * Custom hook for merging options with stable references.
 * Returns defaults when additional is empty, additional when defaults is empty,
 * otherwise concatenated array.
 */
export const useMergedOptions = <T>(
  defaultOptions: T[] | undefined,
  additionalOptions: T[] | undefined
): T[] => {
  return useMemo(() => {
    const defaults = defaultOptions ?? [];
    const additional = additionalOptions ?? [];
    if (additional.length === 0) return defaults;
    if (defaults.length === 0) return additional;
    return [...defaults, ...additional];
  }, [defaultOptions, additionalOptions]);
};
